module.exports = __webpack_public_path__ + "img/31.3b060172.webp";